import React from 'react';
import styled from 'styled-components';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Callout, DirectionalHint } from 'office-ui-fabric-react';
import { getFilterList, ITableRequest } from 'api/handbooks/table';
import {
  DefaultButton,
  PrimaryButton,
  Stack,
  IStackTokens,
  Link, Label
} from 'office-ui-fabric-react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Separator } from 'office-ui-fabric-react/lib/Separator';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import {
  makeFilter,
  FilterComparision,
  IAcceptFilterData,
  makeAllFilter,
  convertMinutesToTime
} from '../../../../utils';
import moment from 'moment';
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const MAX_RECORDS_FOR_FILTER = 100;

interface IProps {
  config: any;
  field: {
    title: string;
    name: string;
    type: string;
    width?: string;
    connection?: string;
    disableFilter?: boolean;
    disableSort?: boolean;
    values?: any[];
    required?: boolean;
  };
  sort: {
    field: string;
    direction: string;
  };
  connection?: {
    config: any;
    list: any[];
  };
  onSortChange?: (field: string, direction: string) => void;
  onFilterShow?: (field?: string) => void;
  showFilter?: boolean;
  allFilters: { [key: string]: IAcceptFilterData };
  onFilterAccept?: (data: IAcceptFilterData) => void;
  externalFilters?: any;
  isInner?: boolean;
}

interface IState {
  filter: string;
  filteredList?: any[];
  filterCount: number;
  loadedCount: number;
  loading: boolean;
  moreLoading: boolean;
  selectedValues: any[];
  isAllSelected: boolean;
  searchValue: string;
  sort: number;
  prevSelectedValues: any[];
  prevIsAllSelected: boolean;
}

const HeadContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const HeadTitle = styled.div<{$disableSort?: boolean}>`
  cursor: ${props => props.$disableSort ? 'default' : 'pointer'};
  display: inline-flex;
  align-items: center;
`;

const FilterButton = styled.div`
  justify-self: flex-end;
  position: relative;
  cursor: pointer;
`;

const ItemsContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;

const LoaderContainer = styled.div`
  display: flex;
  height: 100px;
  justify-content: center;
  alignt-items: center;
`;

const EmptyFilter = styled.div`
  display: flex;
  height: 100px;
  justify-content: center;
  align-items: center;
`;
const HeaderLabel = styled.span<{required?: boolean}>`
  font-size: 16px;
  color: #1a3b5d;

  &::after {
    content: ${({ required }) => (required ? '" *"' : '""')};
    color: red;
    font-weight: normal; /* если не хочешь, чтобы звёздочка была жирной */
  }
`;

class Th extends React.Component<IProps, IState> {
  state = {
    filter: '',
    filteredList: undefined,
    filterCount: 0,
    loadedCount: 0,
    loading: false,
    moreLoading: false,
    isAllSelected: true,
    selectedValues: [] as any[],
    searchValue: '',
    sort: -1,
    prevSelectedValues: [],
    prevIsAllSelected: true,
  };
  pickerRef = React.createRef<HTMLDivElement>();
  last_filter_timeout: number | undefined = undefined;
  prevFilterRequest?: () => void;

  onSortChangeClick = () => {
    const { field, onSortChange, config } = this.props;
    const sortStates = [
      { direction: 'asc', field: field.name },
      { direction: 'desc', field: field.name },
      { direction: config.defaultSort.direction, field: config.defaultSort.field }
    ];
    
    const nextSortState = (this.state.sort + 1) % sortStates.length;
    
    this.setState({ sort: nextSortState });
  
    if (onSortChange) {
      const { direction, field } = sortStates[nextSortState];
      onSortChange(field, direction);
    }
  };

  componentWillUnmount() {
    if (this.last_filter_timeout) {
      clearTimeout(this.last_filter_timeout);
    }
  }

  componentWillReceiveProps(newProps: IProps) {
    if (newProps.showFilter && !this.props.showFilter) {
      this.reloadFilteredData();
    }
    const selectedFilter = (newProps.allFilters || {})[this.props.field.name];
    if (
      selectedFilter != (this.props.allFilters || {})[this.props.field.name]
    ) {
      this.setState({
        isAllSelected:
          (selectedFilter && selectedFilter.isAllSelected) || false,
        filter: (selectedFilter && selectedFilter.filter) || '',
        selectedValues: (selectedFilter && selectedFilter.selectedValues) || [],
      });
    }
  }

  onFilterChange = (vl: string) => {
    if (this.props.config.apiType !== apiTypes.DEFAULT) {
      const selectedValues = this.getFilterList()
        .filter((el: any) => el.value?.includes(vl))
        .map((el: any) => el.data.id);
      
      this.setState({searchValue: vl, selectedValues: selectedValues.length < (this.state.filteredList || []).length ? selectedValues : [], isAllSelected: !(selectedValues.length < (this.state.filteredList || []).length)})
    } else {
      if (this.state.moreLoading) {
        return;
      }
      if (this.last_filter_timeout) {
        clearTimeout(this.last_filter_timeout);
      }
  
      this.setState({ filter: vl }, () => {
        setTimeout(() => {
          this.setState({ isAllSelected: true, selectedValues: [] });
          this.reloadFilteredData();
        }, 300);
      });
    }
  };

  getFilter = (offset:number = 0, limit: number = MAX_RECORDS_FOR_FILTER): ITableRequest => {
    const { config } = this.props;
    let filter: string = '';
    if (!this.props.connection) {
      filter = makeAllFilter({
        ...(this.props.allFilters || {}),
        ...{
          [this.props.field.name]: {
            field: this.props.field,
            filter: this.state.filter,
            selectedValues: [],
            isAllSelected: true,
          },
        },
      });
    } else {
      const connection = this.props.connection;
      filter = makeAllFilter(this.props.allFilters || {});
      if (this.state.filter && this.state.filter.length > 0) {
        const txtFilter = this.state.filter.toLowerCase();
        const indexes = (connection.list || []).filter((cn: any) => {
          return (connection.config.format(cn)+'').toLowerCase().indexOf(txtFilter) >= 0; // !!connection.config.fields.find((fld: any) => (cn[fld] || '').toLowerCase().indexOf(txtFilter) >= 0);
        }).map((cn: any) => `'${cn[connection.config.index]}'`);
        const indFilter = `"${this.props.field.name}"::text like any(array[${indexes.join(',')}])`;
        filter = (filter.length === 0) ? indFilter : `(${filter}) AND (${indFilter})`;
      }
    }
    return {
      schema: config.schema,
      table: config.apiType !== apiTypes.DEFAULT && this.props.field.connection ? this.props.connection?.config.table : config.table,
      fields: config.apiType !== apiTypes.DEFAULT && this.props.field.connection ? this.props.connection?.config.fields : [this.props.field.name],
      sort: {
        field: this.props.field.name,
        direction: 'asc',
      },
      offset,
      limit: config.apiType !== apiTypes.DEFAULT ? 0 : limit,
      distinct: true,
      filters: config.apiType !== apiTypes.DEFAULT
               ? []
               : this.props.externalFilters && this.props.externalFilters != ''
                 ? `(${this.props.externalFilters}) ${filter || filter != '' ? ` AND (${filter})` : ''}`
                 : filter,
      apiType: config.apiType,
      type: config.apiType !== apiTypes.DEFAULT ? 'list' : undefined,
      source: config.apiType !== apiTypes.DEFAULT ? config.table : undefined,
    };

  };

  moreFilters = () => {
    this.setState({ moreLoading: true });
    const params = getFilterList(this.getFilter( this.state.loadedCount*1 || 0 ));
    this.prevFilterRequest = params.cancel;
    params.request.then((data: any) => {
      this.setState({
        filteredList: [...(this.state.filteredList || []), ...((data && data.list) || [])],
        filterCount: (data && data.count) || 0,
        loadedCount: this.state.loadedCount + ((data && data.list) || []).length,
        moreLoading: false,
      });
    });
  }

  reloadFilteredData = async () => {
    this.setState({ loading: true, loadedCount: 0 });
    const params = getFilterList(this.getFilter());
    this.prevFilterRequest = params.cancel;
    params.request.then((data: any) => {
      this.setState({
        filteredList: (data && (this.props.field.type === 'bignumber' ? data.list.map(((item: any) => ({id: item.id?.toString(), name: item.name?.toString()}))) : data.list)) || [],
        filterCount: (data && data.count) || 0,
        loadedCount: this.state.loadedCount+((data && data.list) || []).length,
        loading: false,
      });
    });
  };

  onFilterShowClick = () => {
    this.props.onFilterShow && this.props.onFilterShow(this.props.field.name);
    this.setState({prevSelectedValues: this.state.selectedValues, prevIsAllSelected: this.state.isAllSelected})
  };

  onFilterClose = () => {
    this.props.config.apiType !== apiTypes.DEFAULT && this.setState({selectedValues: this.state.prevSelectedValues, isAllSelected: this.state.prevIsAllSelected, searchValue: ''})
    this.props.onFilterShow && this.props.onFilterShow(undefined);
  };

  onIsAllChecked = (
    ev: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
    vl?: boolean
  ) => {
    this.setState({ selectedValues: [], isAllSelected: vl || false });
  };

  onElementChecked = (element: any, vl?: boolean) => {
    if (this.state.isAllSelected && !vl) {
      const selectedValues = (this.state.filteredList || [])
        .filter((el: any) => this.props.config.apiType !== apiTypes.DEFAULT ? el.id !== element.id : el !== element)
        .map((el: any) => this.props.config.apiType !== apiTypes.DEFAULT ? el.id : el[this.props.field.name]);
        
      this.setState({ selectedValues, isAllSelected: false });
    } else {
      const selectedValues = !vl
        ? this.state.selectedValues.filter(
            (el: any) => this.props.config.apiType !== apiTypes.DEFAULT ? el !== element.id : el !== element[this.props.field.name]
          )
        : [...this.state.selectedValues, this.props.config.apiType !== apiTypes.DEFAULT ? element.id : element[this.props.field.name]];
      
      if (selectedValues.length === (this.state.filteredList || []).length) {
        this.setState({ selectedValues: [], isAllSelected: true });
      } else
        this.setState({
          selectedValues,
          isAllSelected: false,
        });
    }
  };

  onFiltersAccept = () => {
    this.setState({searchValue: '', prevSelectedValues: this.state.selectedValues, prevIsAllSelected: this.state.isAllSelected});
    this.props.onFilterAccept &&
      this.props.onFilterAccept({
        field: this.props.field,
        filter: this.state.filter,
        selectedValues: this.state.selectedValues,
        isAllSelected: this.state.isAllSelected,
        connectionFilterValues: (this.props.field.connection && this.state.isAllSelected) ? (this.state.filteredList || []).map( (el:any) => el[this.props.field.name]) : undefined
      });
    this.props.onFilterShow && this.props.onFilterShow(undefined);
  };

  isFiltered = (): boolean => {
    return (
      this.state.filter !== '' || (this.state.selectedValues || []).length > 0
    );
  };

  getConnectionName = (
    connection: { config: any; list: any[] },
    index: any
  ): string => {
    const _tmp = Array.isArray(index) ? index : [index]

    return _tmp.reduce<any[]>((arr, el) => {
      const cn = connection.list.find(
        (cl) => cl[connection.config.index] == el
      );
      if (cn) {
        return [...arr, connection.config.format(cn)];
      }
      return [...arr, el];
    }, [])
         .join(', ');
  };

  getListName = (list: any[], index: any) => {
    const vl = list.find(
      (elem: { key: any; value: any }) => elem.key === index
    );
    if (vl) {
      return vl.value;
    }
    return index;
  };

  getFormatedField = (value: string) => {
    if (this.props.field.type === 'date') {
      return (value && moment(value).format('DD.MM.YYYY')) || '';
    }
    if (this.props.field.type === 'timeminutes') {
      return (value && convertMinutesToTime(parseInt(value)));
    }
    if (this.props.field.type === 'boolean') {
      return (value && 'Да') || 'Нет';
    }
    return value + '';
  };

  getFilterList = (): { key: any; value: string; data: any }[] => {
    const { field, connection } = this.props;
    if (this.props.config.apiType !== apiTypes.DEFAULT) {
      return (this.state.filteredList || []).map((el) => {
        return {
          key: el['id'],
          value: field.type === 'list'
            ? this.getListName(field.values || [], el['name'])
            : el['name'],
          data: el,
        };
      })
    }
    
    return (this.state.filteredList || []).map((el) => {
      return {
        key: el[field.name],
        value: connection
          ? this.getConnectionName(connection, el[field.name])
          : field.type === 'list'
          ? this.getListName(field.values || [], el[field.name])
          : this.getFormatedField(el[field.name]),
        data: el,
      };
    });
  };

  render() {
    const { field, sort } = this.props;
    return (
      <th 
        style={{ width: field.width || undefined }} 
        rowSpan={!this.props.isInner && field.name === 'dow' ? 1 : 2} 
        colSpan={!this.props.isInner && field.name === 'dow' && this.props.config.apiType !== apiTypes.DEFAULT ? 7 : undefined}
        scope={!this.props.isInner && field.name === 'dow' && this.props.config.apiType !== apiTypes.DEFAULT ? 'colgroup' : this.props.isInner ? 'col' : undefined}
      >
        <HeadContainer>
          <HeadTitle $disableSort={field.disableSort} onClick={field.disableSort ? undefined : this.onSortChangeClick}>
            <HeaderLabel required={field.required}>{field.title}</HeaderLabel>
            
            {field.name !== null && field.name !== undefined && sort.field === field.name && (
              <Icon
                iconName={sort.direction === 'desc' ? 'SortUp' : 'SortDown'}
              />
            )}
          </HeadTitle>
          {field.name !== null && field.name !== undefined && !field.disableFilter && (
            <FilterButton
              ref={this.pickerRef}
              onClick={this.onFilterShowClick}
              {...(field.name === 'id' && {'data-qa': 'filterById'})}
            >
              <Icon iconName={this.isFiltered() ? 'FilterSolid' : 'Filter'} />
              {this.props.showFilter && (
                <Callout
                  styles={{ root: { width: 300 } }}
                  target={this.pickerRef.current}
                  directionalHint={DirectionalHint.bottomRightEdge}
                >
                  <SearchBox
                    placeholder="Фильтр"
                    iconProps={{ iconName: 'Filter' }}
                    onChange={this.onFilterChange}
                  />
                  {this.state.loading && (
                    <LoaderContainer>
                      <Spinner label="Загрузка..." />
                    </LoaderContainer>
                  )}
                  {!this.state.loading &&
                    ((this.state.filteredList || []).length > 0 ? (
                      <Stack
                        horizontal={false}
                        styles={{
                          root: { padding: '10px', minHeight: '100px' },
                        }}
                      >
                        <Checkbox
                          label="Все элементы"
                          checked={this.state.isAllSelected}
                          onChange={this.onIsAllChecked}
                        />
                        <Separator />
                        <ItemsContainer>
                          <Stack
                            horizontal={false}
                            tokens={{ childrenGap: 10 }}
                          >
                            {this.getFilterList().filter((filter: any) => (filter.value ?? '').toString()?.includes(this.state.searchValue)).map((el) => (
                              <Checkbox
                                key={el.key}
                                label={el.value}
                                checked={
                                  this.state.isAllSelected ||
                                  (Array.isArray(el.key)
                                   ? !!this.state.selectedValues.find((value) => JSON.stringify(value) === JSON.stringify(el.key))
                                   : this.state.selectedValues.indexOf(el.key) >= 0)
                                }
                                onChange={(ev, vl) =>
                                  this.onElementChecked(el.data, vl)
                                }
                              />
                            ))}
                          {(this.state.loadedCount<this.state.filterCount) &&
                            (this.state.moreLoading ? <Label styles={{
                              root: {
                              padding: '0'
                            }}}>Загрузка...</Label> : <Link onClick={this.moreFilters} >Показать еще</Link>)}
                          </Stack>
                        </ItemsContainer>
                      </Stack>
                    ) : (
                      <EmptyFilter>Ничего не найдено.</EmptyFilter>
                    ))}
                  <Stack
                    horizontal
                    horizontalAlign={'end'}
                    tokens={{ childrenGap: 10 }}
                  >
                    <PrimaryButton
                      text="Применить"
                      disabled={
                        (!this.state.isAllSelected &&
                          this.state.selectedValues.length === 0) ||
                        (this.state.filteredList || []).length === 0
                      }
                      onClick={this.onFiltersAccept}
                      data-qa='applyFilterBtn'
                    />
                    <DefaultButton text="Отмена" onClick={this.onFilterClose} />
                  </Stack>
                </Callout>
              )}
            </FilterButton>
          )}
        </HeadContainer>
      </th>
    );
  }
}

export default Th;
